import React, { useState } from "react";
import data from "./data.json";

const CrateAccountReport = () => {
    const { header, company, title, form, boxTable, rightTable, buttons } = data;

    const [partyCode, setPartyCode] = useState(form.partyCode.options[0]);
    const [partyName, setPartyName] = useState(form.partyName.options[0]);
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");

    return (
        <div className="w-screen h-screen flex items-center justify-center bg-gray-200 overflow-hidden">
            <div className="w-[95vw] h-[90vh] border-4 border-[#b100b1] shadow-lg bg-white flex flex-col overflow-hidden">
                <div className="bg-[#b100b1] text-white text-sm px-4 py-1 text-center shrink-0">
                    {header.topBar}
                </div>

                <div className="flex-1 border-2 border-black bg-white grid grid-cols-[46%_18%_36%] overflow-hidden">
                    <div className="border-r border-black p-3 flex flex-col gap-4 bg-[#f2f2f2]">
                        <div className="border border-black p-2 bg-[#f8f8f8] text-center">
                            <div className="font-semibold">{company.name}</div>
                            <div className="text-xs">{company.subtitle}</div>
                        </div>

                        <div className="border border-black py-4 flex items-center justify-center text-2xl font-black tracking-wider bg-white">
                            {title}
                        </div>

                        <div className="flex items-center gap-3">
                            <label className="w-36 font-medium">{form.partyCode.label}</label>
                            <select
                                value={partyCode}
                                onChange={(e) => setPartyCode(e.target.value)}
                                className="flex-1 border border-gray-400 px-2 py-1 bg-[#e6e6ff] text-sm"
                            >
                                {form.partyCode.options.map((opt, idx) => (
                                    <option key={idx} value={opt}>
                                        {opt === "" ? " " : opt}
                                    </option>
                                ))}
                            </select>
                        </div>

                        <div className="flex items-center gap-3">
                            <label className="w-36 font-medium">{form.partyName.label}</label>
                            <select
                                value={partyName}
                                onChange={(e) => setPartyName(e.target.value)}
                                className="flex-1 border border-gray-400 px-2 py-1 bg-white text-sm"
                            >
                                {form.partyName.options.map((opt, idx) => (
                                    <option key={idx} value={opt}>
                                        {opt === "" ? " " : opt}
                                    </option>
                                ))}
                            </select>
                        </div>

                        <div className="mt-2 grid grid-cols-1 gap-3">
                            <div className="flex items-center gap-3">
                                <label className="w-36 font-medium">{form.reportFrom.label}</label>
                                <input
                                    type="date"
                                    value={fromDate}
                                    onChange={(e) => setFromDate(e.target.value)}
                                    className="flex-1 border border-black py-2 text-base font-semibold text-center bg-white"
                                />
                            </div>

                            <div className="flex items-center gap-3">
                                <label className="w-36 font-medium">{form.reportTo.label}</label>
                                <input
                                    type="date"
                                    value={toDate}
                                    onChange={(e) => setToDate(e.target.value)}
                                    className="flex-1 border border-black py-2 text-base font-semibold text-center bg-white"
                                />
                            </div>
                        </div>

                        <div className="flex-1" />
                    </div>

                    <div className="border-r border-black p-3 flex flex-col bg-white">
                        <div className="border border-black mb-2 flex flex-col flex-grow-0">
                            <div className="flex">
                                <div className="w-2/3 px-2 py-1 border-r border-black bg-[#fff5b8] text-sm">
                                    Box
                                </div>
                                <div className="w-1/3 px-2 py-1 text-sm">
                                    Qnt
                                </div>
                            </div>
                            <div className="h-[280px] bg-[#f3f6f9]" />
                            <div className="flex items-center border-t border-black">
                                <div className="flex-1 px-2 py-1 text-sm">{boxTable.totalLabel}</div>
                                <div className="w-20 px-2 py-1 text-right border-l border-black">0</div>
                            </div>
                        </div>

                        <div className="grid grid-cols-2 gap-2 mt-auto">
                            {buttons.map((btn, idx) => (
                                <button
                                    key={idx}
                                    className="py-2 rounded-md shadow-inner border border-gray-400 
                 bg-gradient-to-b from-gray-200 to-gray-100 
                 text-sm font-medium 
                 active:translate-y-[1px] 
                 hover:from-gray-100 hover:to-white hover:shadow-md 
                 transition-all duration-200"
                                >
                                    {btn}
                                </button>
                            ))}
                        </div>

                    </div>

                    <div className="p-2 flex flex-col bg-white">
                        <div className="border border-black h-full flex flex-col">
                            <div className="flex">
                                {rightTable.columns.map((col, idx) => {
                                    const isDate = col.toLowerCase() === "date";
                                    return (
                                        <div
                                            key={idx}
                                            className={`flex-1 px-2 py-1 text-sm border-l border-black ${isDate ? "bg-[#ffb3b3]" : "bg-white"
                                                }`}
                                        >
                                            {col}
                                        </div>
                                    );
                                })}
                            </div>
                            <div className="flex-1 bg-[#f6fafc]" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CrateAccountReport;